import Link from 'next/link';
import React from 'react';

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  children: React.ReactNode;
}

const NewTabLink = ({ to, children, className }: Props) => {
  return (
    <Link
      className={className}
      href={to}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </Link>
  );
};

export default NewTabLink;
